export default __webpack_public_path__ + "static/november-pro-light-c9c4788cb38464462f5cbae31577c1b1.woff2";